// components/Header.js
import React,{useRef} from 'react';
import Heading from './Heading';
import Subheading from './Subheading';
import Breadcrumbs from './Breadcrumbs';
import PageInfo from './PageInfo';

const Header = ({ formRef = '', title, steps, subheading, pageinfo }) => {
  return (
    <div className="header">
      <div className="heading-breadcrumbs-wrapper">
        <Heading title={title} />
        <Breadcrumbs steps={steps} />
      </div>
      <Subheading ref={formRef || null} text={subheading} />
      <PageInfo text={pageinfo} />
    </div>
  );
};

export default Header;
